// /venues/:id — Detalle de sala
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ChevronLeft, Heart, MapPin } from 'lucide-react';
import { COLORS, fmtDayPretty, fmtTime } from './designSystem';
import { EventsService } from './EventsService';
import { ColorBlockImage, EventRow, BottomNav, PhoneShell, useSafeBack } from './components';

export default function VenueDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const goBack = useSafeBack('/');
  const [venue, setVenue] = useState(null);
  const [events, setEvents] = useState([]);
  const [tab, setTab] = useState('upcoming');
  const [liked, setLiked] = useState(false);

  useEffect(() => {
    (async () => {
      const [v, e] = await Promise.all([EventsService.getVenue(id), EventsService.getEventsByVenue(id)]);
      setVenue(v); setEvents(e);
    })();
    try { setLiked((JSON.parse(localStorage.getItem('fav_venues') || '[]')).includes(String(id))); } catch (e) { /* noop */ }
  }, [id]);

  const toggleLike = () => {
    let arr = []; try { arr = JSON.parse(localStorage.getItem('fav_venues') || '[]'); } catch (e) { /* noop */ }
    arr = liked ? arr.filter((x) => String(x) !== String(id)) : [...new Set([...arr, String(id)])];
    localStorage.setItem('fav_venues', JSON.stringify(arr));
    setLiked(!liked);
  };

  if (!venue) return (<PhoneShell><p className="p-5 text-white">Cargando…</p></PhoneShell>);

  // Group events by day
  const groups = {};
  events.forEach((e) => {
    const key = e.fecha_inicio ? e.fecha_inicio.slice(0, 10) : (e.day || '—');
    if (!groups[key]) groups[key] = [];
    groups[key].push(e);
  });
  const sortedKeys = Object.keys(groups).sort();

  return (
    <PhoneShell>
      <div className="relative">
        <ColorBlockImage src={venue.image || venue.imagen_url} venueId={venue.id} className="w-full h-[240px]" iconSize={80} />
        <button onClick={goBack} className="absolute top-4 left-4 w-10 h-10 flex items-center justify-center rounded-full backdrop-blur" style={{ backgroundColor: 'rgba(10,10,12,0.6)' }} data-testid="venue-back"><ChevronLeft size={22} color="#fff" /></button>
        <button onClick={toggleLike} className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full backdrop-blur" style={{ backgroundColor: 'rgba(10,10,12,0.6)' }} data-testid="venue-like"><Heart size={20} color="#fff" fill={liked ? COLORS.primary : 'transparent'} /></button>
      </div>

      <div className="px-5 pt-5">
        <h1 className="text-white text-2xl font-extrabold mb-2">{venue.name}</h1>
        <p className="flex items-center gap-1.5 text-sm mb-3" style={{ color: COLORS.textMuted }}><MapPin size={14} />Madrid</p>
        <div className="flex items-center gap-1.5 flex-wrap mb-5">
          <span className="px-2.5 py-1 rounded-full text-[11px] font-semibold" style={{ backgroundColor: COLORS.surfaceAlt, color: COLORS.text }}>+{venue.edad_minima || 18}</span>
          {(venue.estilos || []).map((s) => (<span key={s} className="px-2.5 py-1 rounded-full text-[11px] font-semibold" style={{ backgroundColor: COLORS.surfaceAlt, color: COLORS.text }}>{s}</span>))}
          <span className="px-2.5 py-1 rounded-full text-[11px] font-bold" style={{ backgroundColor: COLORS.primaryDark, color: COLORS.coral }}>Entradas oficiales</span>
        </div>

        <div className="flex gap-2 p-1 rounded-full mb-5" style={{ backgroundColor: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
          <button onClick={() => setTab('upcoming')} className="flex-1 py-2 rounded-full text-sm font-semibold" style={{ backgroundColor: tab === 'upcoming' ? COLORS.primary : 'transparent', color: tab === 'upcoming' ? '#fff' : COLORS.textMuted }} data-testid="venue-tab-upcoming">Próximos eventos</button>
          <button onClick={() => setTab('calendar')} className="flex-1 py-2 rounded-full text-sm font-semibold" style={{ backgroundColor: tab === 'calendar' ? COLORS.primary : 'transparent', color: tab === 'calendar' ? '#fff' : COLORS.textMuted }} data-testid="venue-tab-calendar">Calendario</button>
        </div>

        {events.length === 0 ? (
          <p className="text-sm py-8 text-center" style={{ color: COLORS.textMuted }}>Esta sala aún no tiene eventos próximos.</p>
        ) : (
          <div className="space-y-5 pb-6">
            {sortedKeys.map((k) => {
              const dt = k.includes('-') ? new Date(k) : null;
              return (
                <div key={k}>
                  <h3 className="text-white font-bold mb-2.5 capitalize">
                    {dt ? fmtDayPretty(dt) : k}
                  </h3>
                  <div className="space-y-2.5">
                    {groups[k].map((e) => (<EventRow key={e.id} event={e} onClick={() => navigate(`/eventos/${e.id}`)} />))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <BottomNav />
    </PhoneShell>
  );
}
